import axios from 'axios';
import {useState, useEffect, useCallback} from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@mui/material/Box';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import Loading from '../components/common/Loading';
import Error from '../components/common/Error';
import CustomerReelTypesList from '../components/rts/CustomerReelTypes/CustomerReelTypesList';
import CustomerReelTypesHeader from '../components/rts/CustomerReelTypes/CustomerReelTypesHeader';
import CustomerReelTypesFilter from '../components/rts/CustomerReelTypes/CustomerReelTypesFilter';

import { useSessionContext } from '../contexts/SessionContext';

export default function CustomerReelTypesPage( props ){
    //console.debug("RTS Break CustomerReelTypesPage");

    const history = useNavigate();

    const {curFilter, sessionCustomer, userAuthToken, apiRoot, userLogOut} = useSessionContext();

    const theme = useTheme();
    const smallForm = useMediaQuery(theme.breakpoints.down("sm"));

    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    const [filter, setFilter] = useState(null);
    const [data, setData] = useState([]);

    const fetchData = useCallback((pFilter) => {
        setIsLoading(true);
        let apiURL = apiRoot + "/ReelTypes/GetReelTypeSummary";
        axios
        .post(
            apiURL,
            pFilter,
            {headers:{'Authorization': 'Bearer ' + userAuthToken.token }}
        )
        .then(response => {
            if (response.data) {
                setIsLoading(false);
                setData(response.data);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(error => {
            if(error.code === "ERR_NETWORK"){
                history("/Dashboard"); 
                userLogOut();
            }
            console.log("RTS Data Error", error);
            setHasError(true);
        });
    },[apiRoot, userAuthToken.token, history, userLogOut]);
    

    useEffect(() => {
        props.setIsModalFx(false);
        if(curFilter != null && curFilter.key === 'CustomerReelTypesPage'){
            setFilter(curFilter.filter);
            fetchData(curFilter.filter);
        }
        else{
            setFilter({material:'All', status:-1, customer:sessionCustomer.customer, sortBy:0});
            fetchData({material:'All', status:-1, customer:sessionCustomer.customer, sortBy:0});
        }
    }, [props, curFilter, fetchData, sessionCustomer.customer]); 

    
    const setTableHeight = () => {
        let retValue;

        if(smallForm){
            retValue = 'auto';
        }
        else{
            retValue = '75vh';
        }
        return retValue;
    };    


    if(hasError){
        return(
            <Error />
        );
    }


    if(isLoading){
        return(
            <Loading />
        );
    }

    return(
        <Box id="pageBox">
            <CustomerReelTypesHeader />
            <CustomerReelTypesFilter filter={filter} setFilterFx={setFilter}/>
            <Box sx={{mt:2, height:setTableHeight(), minHeight:'500px'}}>           
                <CustomerReelTypesList data={data} />
            </Box>
        </Box>
    );
}
